import type { JSONContent } from "@tiptap/core";

export type SgidMap = Record<string, any>;

export type TipTapBody = JSONContent & {
  sgids_to_object_map?: SgidMap;
};

const nodeToPlainText = (node: JSONContent, sgidMap: SgidMap): string => {
  switch (node.type) {
    case "text":
      return node.text ?? "";
    case "mention": {
      const obj = sgidMap[node.attrs?.sgid];
      return obj ? `@${obj.name}` : "";
    }
    case "entity": {
      const obj = sgidMap[node.attrs?.sgid];
      return obj ? `#${obj.name}` : "";
    }
    case "hardBreak":
      return "\n";
    case "paragraph":
    default:
      return (node.content ?? [])
        .map(n => nodeToPlainText(n, sgidMap))
        .join("");
  }
};

export const tiptapToPlainText = (
  doc: JSONContent,
  sgidMap: SgidMap,
): string => {
  if (!doc?.content) return "";
  return doc.content.map(n => nodeToPlainText(n, sgidMap)).join("\n");
};
